<template>
  <div class="cart-order-block cart-order-block_receiving">
    <div class="cart-order-block__head">
      <div class="cart-order-block__number-wrap">
        <div class="cart-order-block__number">
          2 / 3
        </div>
      </div>
      <h3 class="cart-order-block__title text__subtitle">
        Способ получения
      </h3>
    </div>

    <div class="cart-order-block__content form-field">
      <ul class="cart-order-block__radio-list">
        <li class="cart-order-block__radio-item">
          <div class="cart-order-block__radio">
            <input type="radio" name="delivery" id="delivery_tk" checked @click="setPickup">
            <label for="delivery_tk" class="cart-order-block__input-label">
              <span class="cart-order-block__label-title texts_heading-13">
                Доставка до терминала тк
              </span>
              <span class="cart-order-block__label-description text text__small">
                <span>от 2 дней</span>
                <span style="font-weight: bold">от 400 ₽</span>
              </span>
            </label>
          </div>
        </li>
        <li class="cart-order-block__radio-item">
          <div class="cart-order-block__radio">
            <input type="radio" name="delivery" id="delivery_courier" value="20" @click="setDelivery">
            <label for="delivery_courier" class="cart-order-block__input-label">
              <span class="cart-order-block__label-title texts_heading-13">
                курьером
              </span>
              <span class="cart-order-block__label-description text text__small">
                <span>от 2 дней</span>
                <span style="font-weight: bold">от 400 ₽</span>
              </span>
            </label>
          </div>
        </li>
      </ul>
    </div>

    <div class="cart-order-block__delivery-additional" v-if="this.receiving === 10">
      <!-- Доставка до терминала-->
      <TheCartOrderReceivingPickup/>
    </div>

    <div class="cart-order-block__delivery-additional" v-if="this.receiving === 20">
      <!-- Доставка курьером-->
      <TheCartOrderReceivingDelivery/>
    </div>

    <popup
        :opened="isModalOpened('delivery_points')"
        :is-processing="isProcessing('delivery_points')"
        @close="closeModal('delivery_points')"
    >
      <DeliveryPoints/>
    </popup>

    <ItemErrors :errors="errors.tkFilled"/>
  </div>
</template>

<script>
import {mapState, mapGetters} from "vuex";
import TheCartOrderReceivingPickup from "./TheCartOrderReceivingPickup.vue";
import TheCartOrderReceivingDelivery from "./TheCartOrderReceivingDelivery.vue";
import CheckedIcon from "../icons/CheckedIcon.vue";
import Popup from "../common/Popup.vue";
import TheCartOrderFast from "./TheCartOrderFast.vue";
import modalMixin from "../../mixins/modal";
import DeliveryPoints from "./TheDeliveryPoints.vue";
import ItemErrors from "./ItemErrors.vue";
import errors from "../parts/common/Errors.vue";
import TheCartDaDataAddress from "./TheCartDaDataAddress.vue";

export default {
  name: "TheCartOrderReceiving",
  components: {
    ItemErrors,
    DeliveryPoints,
    TheCartOrderFast,
    Popup,
    CheckedIcon,
    TheCartOrderReceivingDelivery,
    TheCartOrderReceivingPickup
  },
  computed: {
    receiving: {
      get () {
        return this.$store.state.order.receiving
      },
      set (value) {
        this.$store.commit('order/setReceiving', value);
        this.$store.commit('order/setDeliveryCompany', null);
      }
    },
    ...mapState('order', {
      'errors': 'errors',
    }),
    ...mapGetters('order', {
      'isPickup': 'isPickup',
      'isDelivery': 'isDelivery',
    }),
  },
  methods: {
    setPickup() {
      this.receiving = 10;
    },
    setDelivery() {
      this.receiving = 20;
    },
    openDeliveryPoints() {
      this.openModal('delivery_points');
    }
  },
  mixins: [
    modalMixin,
  ],
}
</script>

<style lang="scss">

</style>